const VIDEO_URL_PATTERN = /\.(mp4|webm|mov|m4v|ogg)(\?|#|$)/i

export const isVideoMediaUrl = (url: string): boolean => {
    if (!url) return false
    return VIDEO_URL_PATTERN.test(url)
}
